import React, { useState, useEffect,useRef  } from 'react';
import withAuth from './../../common/helper/auth-component.js';
import { connect } from 'react-redux';
import LoaderOverlay from './../../common/helper/loader.component.js';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import TicketService from '../../../services/tickets-service.js';
import { MESSAGES } from '../../constants/constants.js';
import { useSelector } from 'react-redux';
import ticketsService from '../../../services/tickets-service.js';



const ViewTicket  = () => { 
  const [ticketDetails, setTicketDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const naviagate = useNavigate()
  const pageEndRef = useRef(null);
  const userData = useSelector(state => state.authReducer);
const [formData,setFormData] = useState({})

  const ViewTicketDetails = () => {
    setLoading(true);
    TicketService.viewTicket(id)
          .then(response => {
            const data =response.data.data
            console.log(data.details)
            setTicketDetails(data)
            setLoading(false);
            setTimeout(() => {
            pageEndRef.current?.scrollIntoView({ behavior: "smooth" });
        }, 0);

          })
          .catch(error => {
            setLoading(false);
            try {
              const errorMessage = error.response.data
              toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
            } catch (e){
              toast.error( MESSAGES.SERVER_ERROR)
            }
          });
  }
useEffect(() => {

  ViewTicketDetails();
    document.body.style.backgroundColor = '#f0f6fa';
    return () => {
      document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
    };
}, []);

const back = () => {
    naviagate('/tickets'); 
}
const reply = () => {
    ticketsService.setViewTicketFormData(formData)
    naviagate(`/reply-ticket/${id}`); 
}
const handleCheckboxChange = (e) => {
    const { name, checked, type, value } = e.target;
    if(name == 'agentTicket') {
        setFormData({
            ...formData,
            agentTicket: e.target.checked,
          
          });
    }
    if(name == 'merchantTicket') {
        setFormData({
            ...formData,
         
            merchantTicket: e.target.checked
          });
    }
    
  };

const formatDate = (dateString) => {
    // Convert the input date string to a Date object in IST
    const date = new Date(dateString);
    const now = new Date();

    // Set the time zone to IST (Indian Standard Time)
    const options = {
        weekday: "short",
        day: "2-digit",
        year: "numeric",
        timeZone: "Asia/Kolkata"  // Set time zone to IST
    };
    const dayDateYear = date.toLocaleDateString("en-US", options);

    // Format time in IST
    const formattedTime = date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
        timeZone: "Asia/Kolkata"  // Ensure time is formatted in IST
    });

    // Calculate the time difference in IST
    const diffInSeconds = Math.floor((now - date) / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    let timeAgo = "";
    if (diffInDays > 0) {
        timeAgo = diffInDays === 1 ? "1 day ago" : `${diffInDays} days ago`;
    } else if (diffInHours > 0) {
        timeAgo = diffInHours === 1 ? "1 hour ago" : `${diffInHours} hours ago`;
    } else if (diffInMinutes > 0) {
        timeAgo = diffInMinutes === 1 ? "1 minute ago" : `${diffInMinutes} minutes ago`;
    } else {
        timeAgo = diffInSeconds < 60 ? "Just now" : `${diffInSeconds} seconds ago`;
    }

    return `${dayDateYear} at ${formattedTime} (${timeAgo})`;
};


    return(
      <><LoaderOverlay loading={loading}/>
        <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
        <h4 style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Ticket Details</h4>
        <div className="row ghty" style={{backgroundColor: 'white', height: 'auto', paddingBottom: '20px'}}>
          <ul className="nav nav-tabs">
            <li className="nav-item tbbtrn">
              <a className="nav-link active_tab1" id="list_per_details">Ticket Details</a>
            </li>
          </ul>
          <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
            <div className="tab-pane active" id="per_details">
              <div className="panel panel-default">
                <div className="panel-body" style={{padding: '0px'}}>
                  

                <div>
        <div className="ticket-container-cashee">
          
          {/* Ticket Meta Section */}
          <div className="ticket-meta-cashee" style={{ display: 'block' }}>
    <div className="meta-item-cashee-header">
        <span className="meta-label">Subject: </span>
        <span className="meta-value">{ticketDetails.subject}</span>
    </div>
    <div className="meta-item-cashee-header">
        <span className="meta-label">Category: </span>
        <span className="meta-value">{ticketDetails.category}</span>
    </div>
    <div className="meta-item-cashee-header">
        <span className="meta-label">Amount: </span>
        <span className="meta-value">{ticketDetails.amount || '-'}</span>
    </div>
    <div className="meta-item-cashee-header">
        <span className="meta-label">Order code: </span>
        <span className="meta-value">{ticketDetails.order_code || '-'}</span>
    </div>
    <div className="meta-item-cashee-header">
        <span className="meta-label">Merchant Order Code: </span>
        <span className="meta-value">{ticketDetails.merchant_order_code || '-'}</span>
    </div>
    <div className="meta-item-cashee-header">
        <span className="meta-label">Ticket For: </span>
        <span className="meta-value">
        <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
        <input
        type="checkbox"
        name="agentTicket"
        
        checked={formData.agentTicket || ticketDetails.is_agent_assign}
         onChange={(e) => handleCheckboxChange(e)} // Add this for user input handling
        disabled={ticketDetails.is_agent_assign}
        style={{ marginTop: 0 }}
        />
        Agent
        </label>
        <label style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
        <input   onChange={(e) => handleCheckboxChange(e)}  type='checkbox' name='merchantTicket' checked =  {formData.merchantTicket ||ticketDetails.is_merchant_assign} disabled={ticketDetails.is_merchant_assign} style={{marginTop:0}}/>
        Merchant
        </label>
        </div>
        </span>
    </div>
</div>


          {ticketDetails && ticketDetails.details && ticketDetails.details.map((ticket, index) => ( 
          <div className="ticket-cashee">
       
            <div className="ticket-info-cashee">
              <div className="ticket-title-container-cashee">
                <div className="profile-initials-cashee">{ticket.replier_info?.charAt(0).toUpperCase()}</div>
                <div className="ticket-title-section-cashee">
                  <h2 className="ticket-title-cashee">{ticket.replier_info}</h2>
                  <div className="reporter-cashee">{ticket.reply_type == 'CREATED' ? 'Reported an Issue' : 'Replied to the issue'}</div>
                </div>
              </div>
              <div className="timestamp-cashee">{formatDate(ticket.created_on)}</div>
            </div>
           
            <div className="ticket-body-container-cashee">
    <div className="ticket-body-cashee">
        {(ticket.utr_id || ticket.screenshot_url) && (
            <div className="ticket-meta-cashee" >
                <div className="utr-id-container">
                    <p className="meta-item-cashee" style={{margin:0}}>UTR ID</p>
                    <p className="utr-id-value">{ticket.utr_id || '-'}</p>
                </div>
                {ticket.screenshot_url && (
                    <div className="meta-item-cashee">
                        <a 
                            href={ticket.screenshot_url} 
                            download="ticket-image.jpg"
                            target="_blank"  // Open in a new window
                            rel="noopener noreferrer"  // For security reasons
                        >
                            <img 
                                src={ticket.screenshot_url} 
                                alt="Ticket" 
                                className="ticket-image" 
                            />
                        </a>
                    </div>
                )}
            </div>
        )}
    </div>
    <div className="ticket-body-cashee">
        <p>{ticket.description}</p>
    </div>
</div>


            
          </div>
))}
        </div>
        {/* Sticky Footer */}
        <div className="sticky-footer-cashee">
        <a style={{width: 'auto', padding: '0px'}} onClick={back}><button className="btn btn-success backbt">Back</button></a>
       
       {ticketDetails.status !='CLOSED' && (
         <a style={{width: 'auto', padding: '0px',}} onClick={reply}><button className="btn btn-success backbt" style={{background:'#198754', color:'white'}}>Reply</button></a>
       )}
       
        </div>
       
      </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div ref={pageEndRef} />
      </div>
      </>
    )

}

function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
export default withAuth(connect(mapStateToProps)(ViewTicket));